import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Icon, Bullet } from 'atoms';
import { GreenTickSvg } from 'components/icons';

const template = styled.div`
  ${({ displayState }) => css`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: ${displayState?.color ? `${displayState?.color}1A` : ''};
    display: flex; 
    align-items: center;
    justify-content: center; 
    cursor: pointer;
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Check',
      renderIf: ({ isSelected }) => isSelected,
      displayValue: ({ color }) => GreenTickSvg({ color })
    },
    {
      component: Bullet,
      name: 'Bullet',
      renderIf: ({ isSelected }) => !isSelected,
      displayValue: ({ }) => '',
      displayState: ({ color }) => ({ color })
    },
  ]
})